import React, { useState,useEffect } from "react";
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import AddIcon from '@mui/icons-material/Add';
import TrashIcon from '@mui/icons-material/Delete';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LaunchIcon from '@mui/icons-material/Launch';
import MessageIcon from '@mui/icons-material/Assignment';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import useStyles from './Styles';
import {Owner,Item} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import BottomButtons from './BottomButtons';
import RowData from './RowData';
import Toast from './Toast';
import Loading from './Loading';
import Title from './Title';
import ItemLabelIcon from './ItemLabelIcon';
import EventNew from './EventNew';
import { Inc, EventTag } from './Inc';
import noImage from './imgs/noimage_profile.png';
import AppBank from './AppBank';

interface EventListProps {
	owner:Owner,
	bank:AppBank,
}

const EventList = (props:EventListProps)=> {
	Ajax.setEditorId( props.owner.owner_id );
	const classes = useStyles();

	const defEventTags:EventTag[] = [];
	const [states,setStates] = useState({
		eventTags: defEventTags,
		year: 0,
		month: 0,
		isLoading: false,
		isEventNewOpen: false,
		toast: "",
	});

	const search = ()=>{
		setStates({...states,"isLoading":true});
		Ajax.send("event/list",{year:states.year,month:states.month},(res:any)=>{
			if( res.ok ){
				setStates({...states,eventTags:res.event_tags,isLoading:false, isEventNewOpen: false,toast:""});
			} else {
				setStates({...states,"isLoading":false});
			}
		});
	}

	const update = (event_tag_id:number | undefined, joined_status:string)=>{
		if( event_tag_id===undefined ) return;
		//setStates({...states,"isLoading":true});
		Ajax.send("event/join",{event_tag_id: event_tag_id, status: joined_status},(res:any)=>{
			if( res.ok ){
				console.log("OK");
				const event_tags = states.eventTags.map( (et)=> {
					if( et.event_tag_id === event_tag_id ){
						et.joined_status = joined_status;
					}
					return et;
				});
				setStates({...states,eventTags:event_tags,isLoading:false,toast:""});
			} else {
				setStates({...states,"isLoading":false});
			}
		});
	}

	const remove = (event_tag_id:number | undefined)=>{
		if( event_tag_id===undefined ) return;
		//setStates({...states,"isLoading":true});
		Ajax.send("event/remove",{event_tag_id: event_tag_id},(res:any)=>{
			if( res.ok ){
				const event_tags = states.eventTags.filter( (et)=> et.event_tag_id !== event_tag_id );
				setStates({...states,eventTags:event_tags,isLoading:false,toast:""});
			} else {
				setStates({...states,"isLoading":false, toast:"削除できませんでした"});
			}
		});
	}

	const closeInput = ()=>{
		setStates({ ...states, isEventNewOpen: false });
	}
	const closeToast = ()=>{
		setStates({...states,"toast":""});
	}

	const addEvent = async (eventTag:any) =>{
		setStates({...states,isLoading:true});
		await Ajax.send("event/add",eventTag,(res:any)=>{
			if( res.ok ){
				search();
				//setStates({...states,isLoading:false, isEventNewOpen: false});
			} else {
				setStates({...states,isLoading:false, toast:"送信に失敗しました。"});
			}
		});
	}

	useEffect( ()=>{
		if( props.owner.owner_id>0 ){
			search();
		}
	},[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	if( states.isLoading ){
		return (
			<Loading isLoading={true}/>
		)
	}
	return (
		<div id="event_list" className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={8} lg={9}>
					<Paper className={classes.paper}>
						<Title text="参加イベント"/>
						<div style={{marginBottom:"3em"}}>
							架空ストアにはイベントごとに参加作家さんを一覧表示する機能があります。<br/>
							あなたが参加したイベント（参加予定も含む）にチェックをして下さい。<br/>
						</div>
						<div style={{textAlign:'right', marginBottom:"2em",padding:"1em", paddingTop:"0.2em", backgroundColor:"#eeeeee", border:"1px solid #dddddd"}}>
							<FormControl style={{ marginRight: "0.5rem" }}>
								<Select
									value={states.year}
									className={classes.select}
									style={{textAlign:"left",width:"7rem",padding:"0.2em 0.5rem",backgroundColor:"#ffffff"}}
									variant="standard"
									onChange={(e) =>
										setStates({ ...states, year: Number(e.target.value) })
									}
								>
									{Array.from({ length: 5 }, (_, i) => (
										<MenuItem key={i} style={{margin:0}} value={new Date().getFullYear() - i}>
											{new Date().getFullYear() - i}年
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl>
								<Select
									value={states.month}
									className={classes.select}
									variant="standard"
									style={{textAlign:"left",width:"7rem",padding:"0.2em 0.5rem",backgroundColor:"#ffffff"}}
									onChange={(e) =>
										setStates({ ...states, month: Number(e.target.value) })
									}
								>
									{Array.from({ length: 12 }, (_, i) => (
										<MenuItem key={i + 1} value={i + 1}>
											{i + 1}月
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl style={{ marginTop: "0.7em" , marginLeft:"0.5em",verticalAlign:"baseline"}}>
								<Button
									variant="contained"
									color="primary"
									style={{height:"2.6em"}}
									disabled={states.year===0 || states.month===0}
									onClick={search}
								>
									検索
								</Button>
							</FormControl>
						</div>
						{states.eventTags.length>0 && (
							<Table>
								<TableHead>
									<TableRow>
										<TableCell className={classes.tableHeadNowrap}>イベント名/開催期間</TableCell>
										<TableCell className={classes.tableHeadNowrap} align="center">参加状況</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{states.eventTags.map( (eventTag,index)=>(
										<TableRow key={index}>
											<TableCell>
												<div style={{color:"teal",fontSize:"110%"}}>{eventTag.event_tag_name}</div>
												<div style={{fontSize:"0.8em",color:"#666666"}}>
												{Tools.formatDate(eventTag.event_start ?? "")}
												{eventTag.event_end &&
												<>
												～
												{Tools.formatDate(eventTag.event_end ?? "")}
												</>
												}
												</div>
												{eventTag.status &&eventTag.status==="0" &&
												<Button onClick={()=>{
													remove(eventTag.event_tag_id);
												}} variant="text" style={{color:"orange",border:"1px solid orange", padding:"0.25rem 0.5rem", fontSize:"0.8rem", lineHeight:"1rem", marginTop:"0.5rem"}}><TrashIcon style={{fontSize:'1rem',marginRight:'0.25rem'}}/>削除</Button>
												}
											</TableCell>
											<TableCell style={{width:"8.25rem"}}>
												<Button onClick={()=>{
													update(eventTag.event_tag_id, "1")
												}} size="small" type="button" variant={ eventTag.joined_status==="1" ? "contained" : "outlined" } color="primary" style={{marginRight:"0.25em"}}>参加</Button>
												<Button onClick={()=>{
													update(eventTag.event_tag_id, "0")
												}} size="small" type="button" variant={ eventTag.joined_status==="0" ? "contained" : "outlined" } color="info">不参加</Button>
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						)}
					</Paper>
				</Grid>
				<Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録" size={2}/>
						<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
							<Button variant="contained" color="primary" style={{width:"100%"}} onClick={() => setStates({ ...states, isEventNewOpen: true })}><AddIcon/>イベントを仮登録</Button>
						</FormControl>
						<Divider style={{marginBottom:"1em"}}/>
                        <ul className={classes.guideUl}>
							<li className={classes.guideLi}>イベントが見つからない場合は仮登録して下さい</li>
                            <li className={classes.guideLi}>仮登録したイベントは、架空ストアで内容の確認後に正式な登録となります</li>
							<li className={classes.guideLi}>仮登録したイベントは、架空ストアでの確認が済むまではいつでも削除できます</li>
							<li className={classes.guideLi}>架空ストアの判断により予告なくイベントの登録（仮登録含む）を削除する場合がありますのであしからずご了承ください</li>
                        </ul>
					</Paper>

				</Grid>
			</Grid>
			<Toast mes={states.toast} close={closeToast}/>
			<EventNew
				isOpen={states.isEventNewOpen}
				yes={addEvent}
				no={closeInput}
			/>
		</div>
	);
}

export default EventList;
